export const generateFullPathText = pathArray => {
  return pathArray.map(p => p.displayText || p.name).join(' / ');
};

export const mapTaskForDropdown = task => {
  const fullPath = task.fullPath || [];
  const hierarchyLevel = Math.max(0, fullPath.length - 1);
  const fullPathText = generateFullPathText(fullPath);

  return {
    id: task.id,
    uri: task.uri,
    displayText: task.displayText || task.name,
    name: task.name,
    code: task.code,
    isClosed: task.isClosed,
    parent: task.parent,
    fullPath: task.fullPath,
    fullPathText,
    hierarchyLevel,
    parents: fullPath.slice(0, -1)
  };
};

export const insertMissingParents = mappedTasks => {
  const result = [];
  const addedUris = new Set();

  mappedTasks.forEach(task => {
    if (task.parents && task.parents.length > 0) {
      task.parents.forEach((parent, index) => {
        if (!addedUris.has(parent.uri)) {
          const parentFullPath = task.parents.slice(0, index + 1);
          const parentFullPathText = generateFullPathText(parentFullPath);

          result.push({
            id: parent.id,
            uri: parent.uri,
            displayText: parent.displayText || parent.name,
            name: parent.name,
            code: null,
            isClosed: true,
            parent: index > 0 ? task.parents[index - 1] : null,
            fullPath: parentFullPath,
            fullPathText: parentFullPathText,
            hierarchyLevel: index,
            parents: task.parents.slice(0, index),
            isParentPlaceholder: true
          });
          addedUris.add(parent.uri);
        }
      });
    }

    result.push(task);
    addedUris.add(task.uri);
  });

  return result;
};

export const transformTasksForDropdown = taskList => {
  if (!taskList || !Array.isArray(taskList)) return [];

  const mappedTasks = taskList.map(mapTaskForDropdown);

  return insertMissingParents(mappedTasks);
};
